import React, { createContext, useContext, ReactNode } from 'react';
import { Product } from '@/data/products';
import { fetchProductById } from '@/services/productService';

interface ProductContextType {
  getProduct: (id: string) => Promise<Product | null>;
}

const ProductContext = createContext<ProductContextType>({
  getProduct: async () => null
});

export const useProducts = () => useContext(ProductContext);

interface ProductProviderProps {
  children: ReactNode;
}

export const ProductProvider = ({ children }: ProductProviderProps) => {
  const getProduct = async (id: string): Promise<Product | null> => {
    try {
      return await fetchProductById(id);
    } catch (error) {
      return null;
    }
  };

  return (
    <ProductContext.Provider value={{ getProduct }}>
      {children}
    </ProductContext.Provider>
  );
}; 